<template>
  <div class="container">
    <Header></Header>
    <div class="dWrap">
      <div class="content">
        <div class="tabs oneTabs">
          <el-tabs v-model="activeName" :disabled="true">
            <el-tab-pane name="0" label="人才供需">
              <div class="jobList">
                <template>
                  <el-collapse accordion>
                    <el-collapse-item v-for="(item, key) in tabsData" :key="key">
                      <template slot="title">
                        <div class="tJob">
                          <div class="workUnit">工作单位：{{ item.workUnit }}</div>
                          <div class="name">岗位：{{ item.title }}</div>
                          <div class="tLocation">
                            <el-popover
                              placement="top-start"
                              title="工作地点"
                              width="200"
                              trigger="hover"
                              :content="item.workAddress"
                            >
                              <span slot="reference">工作地点：{{ item.workAddress }}</span>
                            </el-popover>
                          </div>
                          <div class="tNum">招聘人数：{{ item.workCount }}</div>
                          <div class="time">发布时间：{{ item.createTime }}</div>
                        </div>
                      </template>
                      <div v-html="item.content"></div>
                    </el-collapse-item>
                  </el-collapse>
                </template>
                <img src="@img/empty.png" v-if="!tabsData || tabsData.length === 0" alt="" class="empty" />
              </div>
              <div class="list-page" v-if="tabsData.length > 0">
                <el-pagination
                  layout="prev, pager,sizes, next"
                  :current-page="page.current"
                  @size-change="handleSizeChange"
                  @currentChange="currentChange"
                  :total="page.total"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import moment from 'moment';
export default {
  name: 'home',
  data() {
    return {
      tTitle: '',
      total: 0,
      tabsData: [],
      targetArray: {},
      activeName: '0',
      page: {
        size: 10,
        total: 0,
        current: 1
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$api(
        this.$config.apiUrl.jobList,
        {
          size: 20,
          current: this.page.current
        },
        { method: 'get' }
      )
        .then(data => {
          this.page.total = data.total;
          this.page.current = data.current;

          data.records.forEach(item => {
            if (item.createTime) {
              item.createTime = moment(item.createTime).format('YYYY-MM-DD');
            }
          });

          this.tabsData = JSON.parse(JSON.stringify(data.records));
        })
        .catch(() => {
          console.log('失败');
        });
    },
    currentChange(val) {
      this.page.current = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>

<style lang="less" scoped>
.container {
  min-width: 1198px;
  .dWrap {
    width: 1124px;
    padding: 0 14px;
    margin: 0 auto;
    background: #fff;
    overflow-x: hidden;
  }
  .content {
    padding: 30px 0 0px;
  }
}
.tabs {
  position: relative;
  padding: 0 18px;
  margin-bottom: 18px;
  min-height: 290px;
}
/deep/.el-tabs {
  .el-tabs__header {
    padding-left: 105px;
    padding-top: 10px;
    margin-bottom: 20px;
  }
  .el-tabs__item {
    font-size: 16px;
    color: #000;
    font-weight: normal;
    height: 30px;
    line-height: 30px;
    padding: 0 13px !important;
    box-sizing: border-box;
  }
  .el-tabs__item.is-active {
    color: #000;
  }
  .el-tabs__active-bar {
    height: 4px;
    background-color: #013f99;
    left: -13px;
    right: -13px;
    padding: 0 13px;
    box-sizing: content-box;
  }
  .el-tabs__nav-wrap::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #013f99;
    z-index: 1;
  }
  .el-tab-pane {
    padding-right: 10px;
    padding: 0 15px;
    &.tPl {
      padding-left: 10px;
    }
  }
}
.oneTabs {
  .name {
    display: none;
  }
  /deep/.el-tabs {
    .el-tabs__header {
      padding: 0;
    }
    .el-tabs__active-bar {
      left: 0;
      right: 0;
      padding: 0;
      box-sizing: content-box;
    }
    .el-tabs__item {
      font-weight: 600;
      height: 35px;
      padding: 0 !important;
    }
  }
}
.jobList {
  position: relative;
  min-height: 309px;
  .empty {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    margin: auto;
  }
  /deep/ .el-collapse-item__content {
    padding-top: 20px;
  }
}
.tJob {
  display: flex;
  flex: 1;
  align-items: center;
  line-height: normal;
  .workUnit {
    flex: 1;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .name {
    flex-shrink: 0;
    width: 200px;
    font-size: 16px;
    color: #333;
    font-weight: bold;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tLocation {
    flex-shrink: 0;
    font-size: 14px;
    color: #666;
    display: block;
    width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tNum {
    flex-shrink: 0;
    font-size: 14px;
    color: #666;
    display: block;
    width: 160px;
  }
  .time {
    flex-shrink: 0;
    font-size: 14px;
    color: #666;
    display: block;
    width: 160px;
  }
}
</style>
